import Question from '@/Models/ContextAndQuestions/Question';
import CertificateResponse from '@/Models/Certificates/CertificateResponse';

export default class CertificateQuestion extends Question {
    constructor({ ...rest } = {}) {
        super(rest);
        // Adding aditional attrbutes
        this.certificateResponse = new CertificateResponse();
    }
}